import React from 'react';
import UIComponent from './ui_component.js';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import UIIcon from './icon.js';

const styles = [];

class UIButton extends UIComponent {
  constructor() {
    super();
    this.state = {
    }
  }

  getDefaults(){
    const defaults = {
      className : '',      
      href: '',
      disabled: false,
      onClick: null,
      fab: false,
      color: 'contrast',
    }    
    return defaults;
  }
  
  componentDidMount() {

  }
  
  render() {
    const ico = <UIIcon icon={this.props.icon}/>;
    return (
      (this.state.fab ?
          <Button raised={this.state.fab} color={this.state.color} href={this.state.href} className={this.state.className} onClick={this.state.onClick} disabled={(this.props.disabled) ? this.props.disabled : this.state.disabled} fab>
            {ico}
          </Button>
      :
        (ico && this.props.render === 'icon') ?
          <IconButton disabled={this.props.disabled} color={this.state.color} onClick={this.state.onClick}>
            {ico}
          </IconButton>             
        :      
          <Button raised={this.state.fab} color={this.state.color} href={this.state.href} className={this.state.className} onClick={this.state.onClick} disabled={(this.props.disabled) ? this.props.disabled : this.state.disabled}>
            {ico &&
              ico
            }
            {this.props.children}
          </Button>
      )
    )
  }
}

export default withStyles(styles)(UIButton);


// WEBPACK FOOTER //
// ./src/core/ui/button.js